// extracted by mini-css-extract-plugin
export default {"container":"table_container__2WCgI","table":"table_table__s8Jq8","tableContainer":"table_tableContainer__dEHdW"};